import React from 'react';

const DocumentLink: React.FC<{ name: string; url: string }> = ({ name, url }) => {
  const fileName = decodeURIComponent(url.split('?')[0].split('/').pop() || '');
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="document-card">
      <img src="/pdf.png" alt="PDF Icon" className="document-icon" />
      <span className="document-name">{fileName}</span>
    </a>
  );
};

export default DocumentLink;